module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABWCAMAAAAOjsPAAAAASFBMVEUNryvgaSUNsCtRxmfgUgbgVAngVQrkainneT/nekDphE3rkGDrkWHtnHDtnXHwqoTwqoXwq4b31MH42Mb87+n//v3//v7////kCH9zAAAAAnRSTlPa/ldBP7YAAADISURBVHja7dZbDoMgEIVh2g5S26qUy7j/nfbRaOgDyXgSk/Nv4Eu4DLgbICeAiBAhQoQIESJEiBDpRF6A3AqoG6ml1FMRTVPwIj5MSc9C8rjt5ZhPQeoiu6LaI/Uthz5qjiwix6I1kqVRtkX02UJGNUWSNEumyNRGZlMktJFgiVTfRoZqiBT5U4EgkOWCbDz+COMvI36s4AckftTjH61V49746uU+Elua5jCIDGFOeoXPnX3uAcjdAREhQoQIESJEiBAh0okg+gHS/x4zQlKH9gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/ne.png
// module id = siDs
// module chunks = 0